import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { environment } from '@environments/environment';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';
import { AuxiliarService } from '../auxiliar/auxiliar.service';

@Injectable({
  providedIn: 'root'
})
export class EmailContactoService {

  urlEntidad = environment.api_base_url_backoffice + '/emailContacto';


  public error422Api$: Subject<IRespApi> = new Subject<IRespApi>();

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService
  ) { }

  enviar(request: any): Observable<any> {
    console.log(`${this.urlEntidad}`, request);
    return this.http.post<IRespApi>(`${this.urlEntidad}`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostEmailContacto');
      })
    );
  }

  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  // resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

  // }

  private handleError(err: IRespApi, idRequest = '') {
    // dialog específico
    console.log('CODIGO ERROR ', err);
    if (err.codigoError === 422) {
      console.log('Este es el error 422', err.codigoError);
      err.request = idRequest;
      this.error422Api$.next(err);
    }

    // pantalla común
    let mensaje = err?.mensaje;
    if (err.codigoError === 403) {
      mensaje = `${err.mensaje}: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if (err.data) {
        if (typeof err.data === 'string') {
          avisos = err.data;
        } else {
          err.data.forEach(element => {
            if (element.id === 999) {
              avisos = ' ' + element.mensaje + ' ';
            }
          });
        }
      }
      mensaje = err?.mensaje + avisos;
    }
    return throwError({ 'error': true, 'data': err.data, mensaje });
  }
}
